/**
 * The `table.*` capabilities (CAPABILITIES.md §3.4) that reservations v2 needs: what a person may do
 * with a table. Today one id, `table.orderOnReserved`; the other table ids (`table.transfer`, …) arrive
 * with their flows.
 */
import { definePolicies, definePolicy } from "../engine";
import { permission } from "../requirements";
import type { NoResource } from "../types";

declare module "../types" {
  interface CapabilityMap {
    /**
     * Start an order on a table that is reserved, or transfer a table or items onto one. v1's two
     * outcomes (`AddNewTable`, `TransferTable`, `TransferItem`, `TableSelection`,
     * `getReservedTableMessage`): without the permission the reserved table blocks the action; with
     * it the user is warned and may go on. The old FE asks the same code (`isUserAllowed`).
     * Seating the booking's own guest does not ask it (RESERVATIONS_V2_PLAN.md decision 64: that is
     * `reservation.seat`, from either way in); only an order on the table that is not for its booking does.
     */
    "table.orderOnReserved": NoResource;
  }
}

/**
 * The table policies. `table.orderOnReserved` is disabled without `CREATE_ORDERS_ON_RESERVED_TABLE`,
 * as v1's `featureRestrictions` check. `server: "not enforced"`: no backend code reads that
 * permission (backend.md §7.4), so the frontend is the only gate.
 */
export const TABLE_POLICIES = definePolicies("table", [
  definePolicy<NoResource>("table.orderOnReserved", {
    enabledWhen: [permission("CREATE_ORDERS_ON_RESERVED_TABLE")],
    server: "not enforced",
  }),
]);
